import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BeneficiaryAccountProperties, BeneficiaryAccountAllocationProperties, GetAllocatedAccountsProperties, ERPBackOffliceBankList } from '../Models/BeneficiaryAccountProperties';
import { AllocatedBeneficiaryAccounts } from '../Models/ActiveBeneficiaryAccounts';
import { BaseDataBeneficiaryAccountsAllocation } from '../Models/ActiveBeneficiaryAccounts';
import { UrlRequest } from '../Models/AgencyMasterProperties';

@Injectable({
  providedIn: 'root'
})
export class BeneficiaryService {
  baseUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  createBeneficiary(beneficiaryObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/BeneficiaryAccount/CreateBeneficiaryAccount', beneficiaryObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateBeneficiary(beneficiaryObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/BeneficiaryAccount/UpdateBeneficiaryAccount', beneficiaryObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getBeneficiary(agencyId: string): Observable<BeneficiaryAccountProperties[]> {
    return this.http.get<BeneficiaryAccountProperties[]>(this.baseUrl + '/BeneficiaryAccount/GetBeneficiaryAccount/' + agencyId)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  getBeneficiaryByNo(accountNo: string): Observable<BeneficiaryAccountProperties[]> {
    return this.http.get<BeneficiaryAccountProperties[]>(this.baseUrl + '/BeneficiaryAccount/GetBeneficiaryByAccountNo/' + accountNo)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getBeneficiaryByTitle(title: string): Observable<BeneficiaryAccountProperties[]> {
    return this.http.get<BeneficiaryAccountProperties[]>(this.baseUrl + '/BeneficiaryAccount/GetBeneficiaryByAccountTitle/' + title)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteBeneficiary(num: string): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/BeneficiaryAccount/DeleteBeneficiaryAccount', num, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  createBeneficiaryAccAllocation(beneficiaryObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/BeneficiaryAccount/AllocateBeneficiaryAccounts', beneficiaryObj, this.httpOptions).pipe(map((data: any) => {  return data; }), catchError(error => { return throwError(error); }))
  }

  getActiveBeneficiaryAccounts(agencyid): Observable<BaseDataBeneficiaryAccountsAllocation> {
    return this.http.get<BaseDataBeneficiaryAccountsAllocation>(this.baseUrl + '/BeneficiaryAccount/GetActiveBeneficiaryAccounts/' + agencyid)
      .pipe(map((data: any) => {  return data; }), catchError(error => { return throwError(error); }))
  }
  updateBeneficiaryAccAllocation(beneficiaryObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/BeneficiaryAccount/UpdateBeneficiaryAccAllocation', beneficiaryObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getBeneficiaryAccAllocationById(allocationId: number): Observable<BeneficiaryAccountAllocationProperties[]> {
    return this.http.get<BeneficiaryAccountAllocationProperties[]>(this.baseUrl + '/BeneficiaryAccount/GetBeneficiaryAccAllocationById/' + allocationId)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getBeneficiaryAccAllocationByAgencyId(agencyId: string): Observable<AllocatedBeneficiaryAccounts[]> {
    return this.http.get<AllocatedBeneficiaryAccounts[]>(this.baseUrl + '/BeneficiaryAccount/GetBeneficiaryAccAllocationByAgencyId/' + agencyId)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  getBeneficiaryAccAllocation(agencyId: string): Observable<GetAllocatedAccountsProperties[]> {
    return this.http.get<GetAllocatedAccountsProperties[]>(this.baseUrl + '/BeneficiaryAccount/GetBeneficiaryAllocation/' + agencyId)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteBeneficiaryAllocation(allocationId: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/BeneficiaryAccount/DeleteBeneficiaryAllocation', allocationId, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  statusChangeBeneficiaryAccAllocation(allocationId: number, isActive: boolean): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/BeneficiaryAccount/ChangeStatusBeneficiaryAllocation/' + allocationId + "/" + isActive)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
 
  CheckRightsAgaintAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/BeneficiaryAccount/CheckRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        //console.log(data);
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }


  DeleteBeneficiaryAccAllocation(allocationId: number): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/BeneficiaryAccount/DeleteBeneficiaryAccAllocation/' + allocationId )
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }


  //27-March-24 updated
  statusChangeBeneficiaryAccount(accountNo: string, isActive: boolean, beneficiaryId: number): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/BeneficiaryAccount/ChangeStatusBeneficiaryAccount?accountNo=' + accountNo + "&isActive=" + isActive + "&beneficiaryId=" + beneficiaryId)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  //end

  //27-March-24
  public GetBeneficiaryByIdAndAccount = (beneficiaryId: number, accountNo: string): Observable<BeneficiaryAccountProperties> => {
    return this.http.get<BeneficiaryAccountProperties>(this.baseUrl + '/BeneficiaryAccount/GetBeneficiaryByIdAndAccount?beneficiaryId=' + beneficiaryId + '&accountNo=' + accountNo)
      .pipe(map((data: BeneficiaryAccountProperties) => { return data; }), catchError(error => { return throwError(error); }))
  }
  public CheckBeneficiaryAccountNumberValidation = (beneficiaryId: number, accountNo: string): Observable<boolean> => {
    return this.http.get<boolean>(this.baseUrl + '/BeneficiaryAccount/CheckBeneficiaryAccountNumberValidation?beneficiaryId=' + beneficiaryId + '&accountNo=' + accountNo)
      .pipe(map((data: boolean) => { return data; }), catchError(error => { return throwError(error); }))
  }
  public CheckBeneficiaryIBanValidation = (beneficiaryId: number, ibanNumber: string): Observable<boolean> => {
    return this.http.get<boolean>(this.baseUrl + '/BeneficiaryAccount/CheckBeneficiaryIBanValidation?beneficiaryId=' + beneficiaryId + '&ibanNumber=' + ibanNumber)
      .pipe(map((data: boolean) => { return data; }), catchError(error => { return throwError(error); }))
  }
  public GetERPBackOfficeBankList = (req: UrlRequest): Observable<ERPBackOffliceBankList[]> => {
    return this.http.post<ERPBackOffliceBankList[]>(this.baseUrl + '/ERPBackOffice/GetERPBackOfficeBankList', req).pipe(
      map((data: ERPBackOffliceBankList[]) => {
        return data;
      }), catchError(error => { return throwError(error) })
    );
  }
  //end
}
